import React from 'react';

const MailLabel = () => (
 <svg width="27" height="20" viewBox="0 0 27 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.701567 2.7527C1.02864 1.31171 2.31737 0.236 3.85734 0.236H23.2733C24.8133 0.236 26.102 1.31171 26.4291 2.7527L13.5653 10.6139L0.701567 2.7527ZM0.621338 4.59988V16.0934L10.0109 10.338L0.621338 4.59988ZM11.5613 11.2854L0.931785 17.8008C1.45073 18.8952 2.56565 19.652 3.85734 19.652H23.2733C24.565 19.652 25.6799 18.8952 26.1989 17.8008L15.5694 11.2854L13.5653 12.5101L11.5613 11.2854ZM17.1198 10.338L26.5093 16.0934V4.59988L17.1198 10.338Z" fill="#141414"/>
</svg>
);

export default MailLabel;
